"use strict";

document.addEventListener("DOMContentLoaded", function () {

    let currentQuestion = 1;
    const totalQuestions = 4;

    const nextBtn = document.getElementById("next-btn");
    const backBtn = document.getElementById("back-btn");
    const progressBar = document.getElementById("progress");

    const discountAnimation = document.getElementById("discount-animation");
    const quiz = document.getElementById("quiz");

    if (!nextBtn || !backBtn || !progressBar) {
        // console.error("Quiz elements are missing. Script aborted.");
        return;
    }

    backBtn.style.display = "none";
    nextBtn.disabled = true;

    // -----------------------------
    // CHECK IF OPTION SELECTED
    // -----------------------------
    function checkSelection() {

        const visibleQuestion = document.querySelector(`#question${currentQuestion}`);
        if (!visibleQuestion) return;

        const inputs = visibleQuestion.querySelectorAll("input");

        let selected = false;

        inputs.forEach(input => {
            if (input.checked) selected = true;
        });

        nextBtn.disabled = !selected;
    }

    document.querySelectorAll(".options input").forEach(input => {
        input.addEventListener("change", checkSelection);
    });

    // -----------------------------
    // VALIDATION
    // -----------------------------
    function validateCurrentQuestion() {

        switch (currentQuestion) {

            case 1:
                return document.querySelector('input[name="minority"]:checked') !== null;

            case 2:
                return document.querySelectorAll('input[name="health"]:checked').length > 0;

            case 3:
                return document.querySelector('input[name="concern"]:checked') !== null;

            case 4:
                return document.querySelector('input[name="commitment"]:checked') !== null;

            default:
                return false;
        }
    }

    // -----------------------------
    // PROGRESS BAR
    // -----------------------------
    function updateProgressBar() {
        progressBar.style.width = `${(currentQuestion / totalQuestions) * 100}%`;
    }

    function updateButtonText() {

        nextBtn.textContent = (currentQuestion === totalQuestions)
            ? "Claim My Discount >>"
            : "Next";

    }

    // -----------------------------
    // NEXT BUTTON
    // -----------------------------
    nextBtn.addEventListener("click", () => {

        if (!validateCurrentQuestion()) {
            document.getElementById(`warning${currentQuestion}`).style.display = "flex";
            return;
        }

        if (currentQuestion < totalQuestions) {

            document.getElementById(`question${currentQuestion}`).style.display = "none";

            currentQuestion++;

            document.getElementById(`question${currentQuestion}`).style.display = "block";

            nextBtn.disabled = true;

            updateProgressBar();
            updateButtonText();

            backBtn.style.display = (currentQuestion > 1) ? "block" : "none";
        }

        else {
            
            // console.log("Last question - sending data");

            sendQuizData();

        }

    });

    // -----------------------------
    // BACK BUTTON
    // -----------------------------
    backBtn.addEventListener("click", (e) => {

        e.preventDefault();

        if (currentQuestion > 1) {

            document.getElementById(`question${currentQuestion}`).style.display = "none";

            currentQuestion--;

            document.getElementById(`question${currentQuestion}`).style.display = "block";

            checkSelection();

            updateProgressBar();
            updateButtonText();

            backBtn.style.display = (currentQuestion > 1) ? "block" : "none";
        }

    });

    function showLoader(){
        document.getElementById("pageLoader")?.classList.add("active");
    }

    function hideLoader(){
        document.getElementById("pageLoader")?.classList.remove("active");
    }

    // -----------------------------
    // SEND DATA TO GOOGLE SHEET
    // -----------------------------
    function sendQuizData() {

        // console.log("sendQuizData function");

        const minority = document.querySelector("input[name='minority']:checked")?.value;

        const healthConcerns = [...document.querySelectorAll("input[name='health']:checked")]
            .map(el => el.value)
            .join(", ");

        const biggestConcern = document.querySelector("input[name='concern']:checked")?.value;

        const commitment = document.querySelector("input[name='commitment']:checked")?.value;

        const data = {
            minority: minority,
            healthConcerns: healthConcerns,
            biggestConcern: biggestConcern,
            commitment: commitment
        };

        // console.log(data);

        nextBtn.textContent = "Processing...";
        showLoader();

        fetch("https://script.google.com/macros/s/AKfycbxom525DyL_7jdyYYwKZLYOPad1-mVicXXm60TqzJ_dSTN0yEzr0lg3VhwckskAh8M/exec", {
            method: "POST",
            headers: {
                "Content-Type": "text/plain;charset=utf-8"
            },
            body: JSON.stringify(data)
        }).then(() => {
            // console.log("Data sent to Google Sheet");
            showDiscountAnimation();

        });
    }

    // -----------------------------
    // DISCOUNT ANIMATION
    // -----------------------------
    function showDiscountAnimation() {

        quiz.style.display = "none";
        nextBtn.style.display = "none";
        hideLoader();
        discountAnimation.style.display = "block";

        const circle = document.querySelector(".discount-circle .progress");
        const circumference = 2 * Math.PI * 45;

        circle.style.strokeDasharray = circumference;
        circle.style.strokeDashoffset = circumference;

        const redirectURL = "https://infiniteage.com/pages/vip-sub-offer";

        let discount = 95;
        let currentDiscount = 0;

        const discountInterval = setInterval(() => {

            if (currentDiscount < discount) {

                currentDiscount++;

                document.querySelector(".discount-percentage").textContent =
                    `${currentDiscount}%`;

                const offset = circumference - (currentDiscount / 100) * circumference;

                circle.style.strokeDashoffset = offset;

            }

            else {

                clearInterval(discountInterval);

                setTimeout(() => {

                    discountAnimation.innerHTML = `
                        <h2>Your Discount is Ready!</h2>

                        <div class="discount-circle">
                            <svg viewBox="0 0 100 100">
                                <circle class="background" cx="50" cy="50" r="45"/>
                                <circle class="progress" cx="50" cy="50" r="45"
                                style="stroke-dasharray:${circumference};
                                stroke-dashoffset:${circumference - (discount/100)*circumference};"/>
                            </svg>

                            <div class="discount-percentage">${discount}%</div>
                        </div>

                        <p>Redirecting to your discount offer...</p>
                    `;

                    setTimeout(() => {

                        window.location.href = redirectURL;

                    }, 500);

                }, 100);

            }

        }, 20);

    }

    // -----------------------------
    // INIT
    // -----------------------------
    updateProgressBar();
    updateButtonText();

});